// import { getAximaDomainDetail } from "../../http/aximaHttp/AximaDomainHttp";
import { createPortal } from "react-dom"
import Div from "../Div";
import FormButton from "../FormButton";
import { useState } from "react";
import Input from "../Input";
import { addAximaLicense } from "../../http/aximaHttp/AximaDomainHttp";
import { role } from "../../util/validation";
// import { Subscript } from "@mui/icons-material";

function AddAximaLicenseModal({ domain, handleClicked, ...props }) {

    const [inputDomain, setInputDomain] = useState()

    function handleClose() {
        handleClicked(false);
    }

    async function handleAddLicenseClick(){
      
        const response = await addAximaLicense(parseInt(domain.user_count) + parseInt(inputDomain), 
            domain.subscription_id)
        if (response === 200){

            window.location.href = '/home/add_axima_domain'
        }
        else{
            alert('Failed to add License..!!')
        }

    }

    return (
        <>
            {createPortal(
                <Div className="modal-backdrop">
                    <dialog {...props}
                    // style={{ zIndex: '1', maxWidth: '85%' }}
                    >
                       
                        <Div className="form-group">
                            Add Axima Domain
                        </Div>
                        <Div className='scroll-container'
                            style={{
                                overflowY: "auto",
                                height: "304px",
                                width: "100%",
                                border: "1px solid #000",
                                padding: "10px",
                            }}>

                            <Div className="form-group">
                                <Input text='' type="text" className="form-control" disabled={ role === 'ADEPLOY' ? true : false} value={domain.domain_name} />
                            </Div>

                            <Div className="form-group">
                                <Input text='' type="text" className="form-control" disabled={ role === 'ADEPLOY' ? true : false} value={domain.product_name} />
                            </Div>

                            <Div className="form-group">
                                <Input text='' type="text" className="form-control" disabled={ role === 'ADEPLOY' ? true : false} value={domain.user_count} />
                            </Div>

                            <Div className="form-group">
                                <Input text='' onInput={(e) => setInputDomain(e.target.value)} type="text" className="form-control"
                                 placeholder="Enter License to Add" />
                            </Div>


                            <Div className='row' style={{ marginTop: '10px' }}>
                                 <Div className='col-sm-6'>
                                    <FormButton type='submit' style={{ margin: '2px' }} onClick={handleAddLicenseClick}
                                        className="btn btn-primary submit-btn btn-block">Add License</FormButton>
                                </Div>
                                <Div className='col-sm-6'>
                                    <FormButton type='button' onClick={handleClose} style={{ margin: '2px' }} className="btn btn-primary submit-btn btn-block" >Close</FormButton>
                                </Div>
                            </Div>
                        </Div>
                    </dialog>

                </Div>
                , document.getElementById('modal'))

            }
        </>
    )
}

export default AddAximaLicenseModal;